<template>
	<div class="about">
		<div class="collapse-wrap">

			<div class="search-bar">
				<h3>{{ tableData[dataType].name }}</h3>
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>检查日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width: 220px"
								type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions"
								@change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<label>入组日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width: 220px"
								type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" v-model="filter.date2" :picker-options="pickerOptions"
								@change="handleFilter(2, $event)"></el-date-picker>
						</label>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport"><i
								class="icon-export" style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading">
					<CustomTableColumn prop="patientGroupCount" :label="tableData[dataType].name" routeName="Patient/GroupView" datasources="0" :extraQueryParams="{ groupingId:groupingId,date:filter.date2}"></CustomTableColumn>

					<CustomTableColumn prop="afpCount" label="甲胎蛋白检验人数" routeName="Patient/GroupView" datasources="0" :extraQueryParams="{ groupingId:groupingId,date:filter.date2,lisTagIds:1}"></CustomTableColumn>
					<el-table-column  :label="labeltit[dataType].name" show-overflow-tooltip>
						<CustomTableColumn prop="hepatitisPositiveCount" label="阳性" routeName="Patient/GroupView" datasources="0" :extraQueryParams="{ groupingId:groupingId,date:filter.date2,lisTagIds:posId}"></CustomTableColumn>
						<CustomTableColumn prop="hepatitisNegativeCount" label="阴性" routeName="Patient/GroupView" datasources="0" :extraQueryParams="{ groupingId:groupingId,date:filter.date2,lisTagIds:negId}"></CustomTableColumn>
						<!-- <el-table-column prop="hepatitisCount" label="合计" width="130"></el-table-column> -->
						<CustomTableColumn prop="hepatitisCount" label="合计" routeName="Patient/GroupView" datasources="0" :extraQueryParams="{ groupingId:groupingId,date:filter.date2,lisTagIds:posId+','+negId,lisRelation:2}"></CustomTableColumn>

					</el-table-column>
					<el-table-column prop="lcsRate" label="肝癌筛查率" width="130">
						<template slot="header">
							肝癌筛查率
							<img @click="openModal('header')" class="t-img" src="../../../assets/images/question-fill.png"
								alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.lcsRate }}</span>
							<img @click="openModal('column', scope.row)" class="t-img"
								src="../../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column prop="viRate" label="病毒抑制率" width="130" show-overflow-tooltip>
						<template slot="header">
							病毒抑制率
							<img @click="openModal('header1')" class="t-img" src="../../../assets/images/question-fill.png"
								alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.viRate }}</span>
							<img @click="openModal('column1', scope.row)" class="t-img"
								src="../../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
				</el-table>

			</div>
		</div>
		<ModalCommon :dlg.sync="dlg" v-if="dlg.visible" />
	</div>
</template>

<script>
import api from "@/service/api.js";
import mixin from "@/views/mixin";
import dayjs from "dayjs";
import ModalCommon from './modalCommon.vue';
import CustomTableColumn from '../components/tableColumn.vue';

export default {
	mixins: [mixin],
	components: { ModalCommon,CustomTableColumn },
	props: {
		dataType: {
			required: true
		}
	},
	data() {
		return {
			noSidebar: true,
			tableData: {
				'HBV': {
					name: '乙肝人数',
				},
				'HCV': {
					name: '丙肝人数',
				}
			},
			labeltit: {
				'HBV': {
					name: '乙肝DNA测定结果(人数)',
				},
				'HCV': {
					name: '丙肝RNA测定结果(人数)',
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: [],
				summary: [],
			},
			filter: {
				groupDateStart: "",
				groupDateEnd: "",
				lisDateStart: "",
				lisDateEnd: "",
				pageNumber: 1,
				pageSize: 10,
				date: [],
				date2:[]
			},
			permission: false,
			dlg: {
				visible: false,
				type: '',
				propname: 'liverCancer',
				data: {},
				dataType:''
			},
			groupingId:0,
			posId:0,
			negId:0
		};
	},
	created(){
		switch (this.dataType){
				case 'HBV':
					this.groupingId=29
					this.posId=2
					this.negId=3
				break;
				case 'HCV':
					this.groupingId=28
					this.posId=4
					this.negId=5
				break;
			}
	},
	mounted() {
		this.loadList();
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res ;
			switch (this.dataType){
				case 'HBV':
					res = await api.getHepatitisBReport(this.filter);
					this.groupingId=29
				break;
				case 'HCV':
					res = await api.getHepatitisCReport(this.filter);
					this.groupingId=28

				break;
			}
			
			if (res.code == 500) {
				return this.$router.push({
					name: "Login",
					query: {
						r: location.href
					},
				});
			}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.code == 1000 && res.data) {
				this.list.data=[res.data];
			}
			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
			this.isLoading = false;
		},
		getSummaries() {
			this.$nextTick(() => {
				this.$refs['multipleTable'].doLayout();
			});
			return this.list.summary;
		},
		
		// 过滤条件 更改
		handleFilter(key, val) {
			switch (key) {
				case 0:
					if (this.filter.date) {
						this.filter.lisDateStart = dayjs(
							this.filter.date[0]
						).format("YYYY-MM-DD 00:00:00");
						this.filter.lisDateEnd = dayjs(this.filter.date[1]).format(
							"YYYY-MM-DD 23:59:59"
						);
					} else {
						this.filter.lisDateStart = "";
						this.filter.lisDateEnd = "";
					}
					break;
				case 2:
					if (this.filter.date2) {
						this.filter.groupDateStart = dayjs(
							this.filter.date2[0]
						).format("YYYY-MM-DD 00:00:00");
						this.filter.groupDateEnd = dayjs(this.filter.date2[1]).format(
							"YYYY-MM-DD 23:59:59"
						);
					} else {
						this.filter.groupDateStart = "";
						this.filter.groupDateEnd = "";
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		exportReport() {
			this.filter.pageSize = this.list.total;
			let url;
			switch (this.dataType){
				case 'HBV':
					url = api.exportlListBReportExport(this.filter);
				break;
				case 'HCV':
					url = api.exportlListCReportExport(this.filter);
				break;
			}
			const tempLink = document.createElement("a");
			tempLink.style.display = "none";
			tempLink.href = url;
			tempLink.target = "_blank";
			document.body.appendChild(tempLink);
			tempLink.click();
			document.body.removeChild(tempLink);
			this.filter.pageSize = 10;

		},
		openModal(type, data) {
			this.dlg.data = data;
			this.dlg.type = type;
			this.dlg.dataType=this.dataType;
			this.dlg.visible = true;
		}
	},
};
</script>

<style lang="less" scoped>
@import "@/assets/style/var";
@import './sty.less';

h3 {
	margin-left: 20px;
}

.table-wrap {
	padding: 20px 20px 40px;
}</style>